module.exports = __webpack_public_path__ + "img/banner.3347f185.jpeg";